import { TRegionDashboardStoreState } from './types';

export function getBaseRegionInfo(state: TRegionDashboardStoreState) {
  return state.baseRegionInfo;
}

export function getRatingCards(state: TRegionDashboardStoreState) {
  return state.ratingCards;
}

export function getRatingList(state: TRegionDashboardStoreState) {
  return state.ratingList;
}

export function getIndicatorCards(state: TRegionDashboardStoreState) {
  return state.indicatorCards;
}

export function getDynamicCards(state: TRegionDashboardStoreState) {
  return state.dynamicCards;
}

export function getEventsCountByTypes(state: TRegionDashboardStoreState) {
  return state.eventsCountByTypes;
}

export function getAgreementsCountByTypes(state: TRegionDashboardStoreState) {
  return state.agreementsCountByTypes;
}

export function getRepresentativeAbroadInfo(state: TRegionDashboardStoreState) {
  return state.representativeAbroadInfo;
}

export function getRepresentativeAbroadInfoTable(state: TRegionDashboardStoreState) {
  return state.representativeAbroadInfoTable;
}
